const HeatBadge = ({ heat, compact = false }: { heat: number; compact?: boolean }) => {
  const tone =
    heat >= 90
      ? 'bg-accent-500 text-background-50'
      : heat >= 75
        ? 'bg-secondary-400 text-secondary-950'
        : 'bg-secondary-100 text-secondary-800';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full ${compact ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'} font-medium whitespace-nowrap ${tone}`}
      title={`吃瓜热度 ${heat}`}
    >
      <i className="ri-fire-line" />
      {heat}
    </span>
  );
};

export default HeatBadge;